import { SelectItem } from 'primeng/api';

export enum BaseCurrencyIsoCode {
  USD = 'USD',
  GBP = 'GBP',
  EUR = 'EUR',
  JPY = 'JPY',
  CNY = 'CNY',
  KRW = 'KRW',
  CAD = 'CAD',
  CHF = 'CHF',
  AUD = 'AUD',
}

// Manually sorted by label
export const BASE_CURRENCY_ISO_CODE_SELECT_ITEMS: SelectItem[] = [
  { label: 'USD', value: BaseCurrencyIsoCode.USD },
  { label: 'AUD', value: BaseCurrencyIsoCode.AUD },
  { label: 'CAD', value: BaseCurrencyIsoCode.CAD },
  { label: 'CHF', value: BaseCurrencyIsoCode.CHF },
  { label: 'CNY', value: BaseCurrencyIsoCode.CNY },
  { label: 'EUR', value: BaseCurrencyIsoCode.EUR },
  { label: 'GBP', value: BaseCurrencyIsoCode.GBP },
  { label: 'JPY', value: BaseCurrencyIsoCode.JPY },
  { label: 'KRW', value: BaseCurrencyIsoCode.KRW },
];
